import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { ApiTravelMessagingService } from './travel-messaging.service';
import { ApiAuthService } from '../auth';
import { ApiService } from '../api.service';
import { toLuxon } from '../helpers';
import { AbstractChatService } from '@app/chat';
import { Observable } from 'rxjs';
import { ApiMessagingService } from '../messaging';

@Injectable()
export class TravelChatService extends AbstractChatService {
  public travel: any;
  public user: any;
  public type: any;

  constructor(
    private _api: ApiService,
    private _apiAuth: ApiAuthService,
    private _apiMessaging: ApiMessagingService,
    private _apiTravelMessaging: ApiTravelMessagingService,
    injector: Injector,
  ) {
    super(injector);
  }

  init(travel: any = null, user: any, type = 'default') {
    this.travel = travel;
    this.user = user;
    this.type = type;
  }

  loader(data: any) {
    return this._apiTravelMessaging.listMessage({
      id: this.travel.id,
      type: this.type,
      discussion: this.discussion.id,
      ...data,
    });
  }

  muter(data: any, mute: boolean) {
    if (mute) {
      return this._apiTravelMessaging.muteUser({
        id: this.discussion.id,
        user: data.user?.id,
      });
    } else {
      return this._apiTravelMessaging.unmuteUser({
        id: this.discussion.id,
        user: data.user?.id,
      });
    }
  }

  override discussionLoader(data: any): Observable<any> {
    return this._apiTravelMessaging.listDiscussion({
      id: this.travel.id,
      metas: { travelId: this.travel.id, type: this.type },
      userMetas: { userId: this.user.id },
      ...data,
      sort: [['mm.created', 'desc']],
    });
  }

  override discussionViewer(data: any): Observable<any> {
    return this._apiMessaging.setDiscussionViewed({
      id: this.discussion.id,
    });
  }

  sender(data: any) {
    if (data.message) {
      return this._apiTravelMessaging.updateMessage({
        id: this.travel.id,
        discussion: this.discussion?.id,
        type: this.type,
        user: this.user.id,
        ...data,
      });
    } else {
      return this._apiTravelMessaging.sendMessage({
        id: this.travel.id,
        discussion: this.discussion?.id,
        type: this.type,
        user: this.user.id,
        ...data,
      });
    }
  }

  getUserPictureUrl(user: any): string {
    const userId = user.metas.find((m: any) => m.key === 'userId')?.value;
    return this._api.options.apiUrl + 'user/stream/id/' + userId;
  }

  getUserPictureBackground(user: any): any {
    return "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 170.41 185.38'%3E%3Cdefs%3E%3Cstyle%3E *%7B fill: %23CCC; %7D %3C/style%3E%3C/defs%3E%3Cpath d='M0,152.32c3.22-6.62,6.84-13,11.18-18.96,4.43-6.07,9.45-11.58,15.02-16.63,6.48-5.88,13.66-10.69,21.47-14.57,2.68-1.33,5.51-2.38,8.31-3.48,.5-.2,1.27-.17,1.73,.08,6.13,3.35,12.66,5.5,19.56,6.5,6.95,1,13.86,.65,20.7-.91,5.08-1.16,9.93-2.93,14.51-5.45,.61-.33,1.6-.37,2.26-.13,5.72,2.04,11.11,4.78,16.28,7.98,7.36,4.55,13.9,10.08,19.77,16.39,6.88,7.4,12.69,15.59,17.32,24.59,.78,1.52,1.54,3.07,2.3,4.6-1.68,1.51-3.35,3.03-5.03,4.53-1.64,1.47-3.22,3.01-4.96,4.35-1.12,.86-2.52,1.36-3.72,2.12-2.48,1.56-4.89,3.23-7.37,4.77-2.33,1.45-4.61,3.07-7.12,4.12-5.76,2.43-11.64,4.58-17.49,6.79-2.35,.89-4.71,1.75-7.13,2.41-2.73,.75-5.51,1.35-8.3,1.86-2.75,.51-5.53,.88-8.3,1.21-2.82,.34-5.66,.63-8.5,.8-2.05,.13-4.11,.08-6.16,.01-5.28-.16-10.6-.05-15.84-.66-5.35-.62-10.68-1.47-15.93-2.91-6.11-1.68-12.13-3.57-17.98-5.99-3.77-1.56-7.57-3.09-11.13-5.05-4.24-2.32-8.37-4.9-12.31-7.7-4.21-3-8.16-6.38-12.2-9.61-.36-.29-.63-.71-.93-1.07Z'/%3E%3Cpath d='M85.36,0c25.42-.35,47.61,21.09,46.84,48.09-.72,25.26-20.64,45.96-47.3,45.86-25.85-.1-46.79-20.71-46.72-47.5C38.24,21.07,59.4-.43,85.36,0Z'/%3E%3C/svg%3E%0A";
  }

  uploader(data: any) {
    return this._api
      .upload('messaging/media-upload', data)
      .pipe(map((result) => result.data));
  }

  getMediaUrl(media: any, mediaId: number, sizeId = 'thumb') {
    let url =
      this._api.options.apiUrl + 'messaging-message/stream/id/' + media.id;
    if (mediaId) {
      url += '/media/' + mediaId;
    }
    if (sizeId) {
      url += '/size/' + sizeId;
    }
    if (media.modified) {
      url += '?' + toLuxon(media.modified.date)?.toMillis();
    } else {
      url += '?' + toLuxon(media.created?.date)?.toMillis();
    }
    return url;
  }

  override messageRemover(data: any): Observable<any> {
    return this._apiTravelMessaging.removeMessage({
      discussion: this.discussion.id,
      type: this.type,
      id: this.travel?.id,
      message: data?.id,
    });
  }

  override messageFormatter(message: any) {
    message.medias = message.medias.map((media: any) => ({
      ...media,
      preview: this.getMediaUrl(message, media.id),
      base: this.getMediaUrl(message, media.id, 'base'),
    }));

    return message;
  }

  puller(data: any) {
    return this._apiTravelMessaging.pull({
      id: this.travel.id,
      type: this.type,
      discussionUserMetas: { userId: this.user.id },
      ...data,
    });
  }
}
